module.exports = __webpack_public_path__ + "img/shield.fb4d882b.svg";